import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import axios from 'axios';
import wlcBtnNext from "./components/wlc-btn-next.vue";
import { mapActions } from "vuex";
import util from "@/libs/util.js";
import { appendUrlParam } from '@/utils/url';
var perceptionCode = {
  PHiuUt: "诈骗",
  orTPeJ: "中介/二房东"
};
export default {
  components: {
    wlcBtnNext: wlcBtnNext
  },
  name: "used-update",
  data: function data() {
    return {
      videoVisible: false,
      btnNextVisible: false,
      cityList: [],
      // 城市列表
      districtList: [],
      // 区域列表
      categoryList: [],
      // 分类列表

      form: {
        imgs: [],
        cover: "",
        title: "",
        content: "",
        originalPrice: "",
        presentPrice: "",
        cityId: "",
        districtId: "",
        categoryId: ""
      },
      userForm: {},
      previewDialogVisible: false,
      imageRotateDialogVisible: false,
      imageRotateUrl: "",
      imageRotateKey: "",
      userTag: [],
      deviceRisk: {},
      addDataList: [{
        views_num: 19,
        collect_num: 0
      }, {
        views_num: 39,
        collect_num: 1
      }, {
        views_num: 79,
        collect_num: 2
      }, {
        views_num: 99,
        collect_num: 3
      }],
      tagList: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getUsedCategoryList();
            _this.getCityList();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  computed: {
    getPerceptionCodeName: function getPerceptionCodeName() {
      return perceptionCode[this.deviceRisk.perception_code] ? perceptionCode[this.deviceRisk.perception_code] : "";
    }
  },
  watch: {
    "$route.query.id": function $routeQueryId() {
      this.userTag = [];
      this.loading = true;
      this.getData();
      this.btnNextVisible = false;
      this.releaseCompleteState = false;
      var containerBody = document.getElementsByClassName("d2-container-full__body")[0];
      containerBody.scrollTop = 0;
    },
    previewDialogVisible: function previewDialogVisible() {
      var _this2 = this;
      this.$nextTick(function () {
        if (_this2.previewDialogVisible) {
          document.addEventListener('keydown', _this2.keydownEventHandle);
        } else {
          document.removeEventListener('keydown', _this2.keydownEventHandle);
        }
      });
    },
    "form.url": function formUrl() {
      if (this.form.url) {
        this.form.imgs.push(this.form.url);
      }
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("d2admin/page", ["close"])), {}, {
    thumbnailUrl: function thumbnailUrl(url) {
      return url ? appendUrlParam(url, 'imageView2/0/w/400/h/400') : '';
    },
    closeRotateDialog: function closeRotateDialog() {
      this.imageRotateDialogVisible = false;
    },
    saveRotateImgUrl: function saveRotateImgUrl(url) {
      this.form.imgs.splice(this.imageRotateKey, 1, url);
      if (this.imageRotateUrl == this.form.cover) {
        this.form.cover = url;
      }
    },
    selectRotateImg: function selectRotateImg(key) {
      this.imageRotateKey = key || 0;
      this.imageRotateUrl = this.form.imgs[this.imageRotateKey];
      this.imageRotateDialogVisible = true;
    },
    keydownEventHandle: function keydownEventHandle(event) {
      if (event.key === 'ArrowLeft') {
        this.$refs.carousel.prev();
      }
      if (event.key === 'ArrowRight') {
        this.$refs.carousel.next();
      }
    },
    previewImage: function previewImage(index) {
      var _this3 = this;
      this.previewDialogVisible = true;
      this.$nextTick(function () {
        setTimeout(function () {
          _this3.$refs.carousel.setActiveItem(index);
        });
      });
    },
    getUserDeviceRisk: function getUserDeviceRisk() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this4.$api.getUserDeviceRisk({
                user_id: _this4.form.userId
              });
            case 1:
              res = _context2.v;
              _this4.deviceRisk = res.data;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getUsersTagList: function getUsersTagList() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this5.$api.getUsersTagList({
                top: 5,
                user_id: _this5.form.userId
              });
            case 1:
              res = _context3.v;
              if (res.data[_this5.form.userId]) {
                _this5.userTag = res.data[_this5.form.userId];
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    // 审核
    audit: function audit(status) {
      var _this6 = this;
      this.$confirm("是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this6.save('audit');
            case 1:
              _context4.n = 2;
              return _this6.$api.auditUsed({
                id: _this6.$route.query.id,
                status: status,
                adminId: util.cookies.get("uuid")
              });
            case 2:
              _this6.$message.success("操作成功");

              // 操作上报
              _this6.$operationLog.push({
                code: status == 1 ? 'pass' : 'reject',
                userId: _this6.userForm.id,
                operationType: "used",
                detailBatchNo: _this6.$route.query.id
              });
              _this6.form.status = status;
              _this6.btnNextVisible = true;
            case 3:
              return _context4.a(2);
          }
        }, _callee4);
      }))).catch(function () {});
    },
    // 推荐|取消推荐
    recommend: function recommend() {
      var _this7 = this;
      this.$confirm("是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this7.$api.recommendUsed({
                id: _this7.$route.query.id,
                type: _this7.form.isRecommend == 1 ? 0 : 1
              });
            case 1:
              _this7.$message.success("操作成功");
              _this7.getData();

              // 操作上报
              _this7.$operationLog.push({
                code: _this7.form.isRecommend == 1 ? 'unrecommend' : 'recommend',
                userId: _this7.userForm.id,
                operationType: "used",
                detailBatchNo: _this7.$route.query.id
              });
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))).catch(function () {});
    },
    saveUserInfo: function saveUserInfo() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return _this8.$api.updateUser({
                userId: _this8.userForm.id,
                update: {
                  avatar: _this8.userForm.avatar,
                  name: _this8.userForm.name,
                  remark: _this8.userForm.remark
                }
              });
            case 1:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    getUserInfo: function getUserInfo(id) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return _this9.$api.getUserInfo({
                id: id
              });
            case 1:
              res = _context7.v;
              _this9.userForm = res.data;
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    getUsedCategoryList: function getUsedCategoryList() {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var res;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return _this0.$api.getUsedCategoryList();
            case 1:
              res = _context8.v;
              _this0.categoryList = res.data;
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    getCityList: function getCityList() {
      var _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var res;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _context9.n = 1;
              return _this1.$api.getCityList({
                isOpen: 1,
                ps: 100
              });
            case 1:
              res = _context9.v;
              _this1.cityList = res.data.list;
            case 2:
              return _context9.a(2);
          }
        }, _callee9);
      }))();
    },
    getDistrictList: function getDistrictList(cityId) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var res;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              _context0.n = 1;
              return _this10.$api.getDistrictList({
                id: cityId
              });
            case 1:
              res = _context0.v;
              _this10.districtList = res.data;
            case 2:
              return _context0.a(2);
          }
        }, _callee0);
      }))();
    },
    getData: function getData() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var res;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              _context1.n = 1;
              return _this11.$api.getUsedInfo({
                id: _this11.$route.query.id
              });
            case 1:
              res = _context1.v;
              _this11.getUserInfo(res.data.userId);
              res.data.imgs = res.data.imgs || [];
              _this11.form = res.data;
              _this11.getDistrictList(_this11.form.cityId);
              _this11.getUsersTagList();
              _this11.getUserDeviceRisk();
            case 2:
              return _context1.a(2);
          }
        }, _callee1);
      }))();
    },
    save: function save(type) {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              _this12.saveUserInfo();
              _context10.n = 1;
              return _this12.$api.updateUsed(_this12.form);
            case 1:
              _this12.$message.success("保存成功");
              if (type != 'audit') {
                // 操作上报
                _this12.$operationLog.push({
                  code: 'save',
                  userId: _this12.userForm.id,
                  operationType: "used",
                  detailBatchNo: _this12.$route.query.id
                });
              }
            case 2:
              return _context10.a(2);
          }
        }, _callee10);
      }))();
    },
    imageUrlToFile: function imageUrlToFile(url, filename) {
      return fetch(url).then(function (response) {
        return response.blob();
      }).then(function (blob) {
        return new File([blob], filename, {
          type: 'image/jpeg'
        });
      });
    },
    setCover: function setCover(url) {
      this.form.cover = url;
    },
    deleteImage: function deleteImage(index, img) {
      var _this13 = this;
      this.form.imgs.splice(index, 1);
      if (img == this.form.cover) {
        this.$nextTick(function () {
          _this13.form.cover = _this13.form.imgs[0];
        });
      }
    },
    selectVideoPreview: function selectVideoPreview() {
      var _this14 = this;
      var video = document.getElementById("J_video");
      var currentTime = Math.round(video.currentTime);
      this.form.cover = appendUrlParam(this.form.video, "vframe/jpg/offset/".concat(currentTime));
      this.form.video_cut_start_frame = currentTime;
      this.videoVisible = false;
      this.imageUrlToFile(this.form.cover, 'myImage.jpg').then(function (file) {
        _this14.$api.getQiniuToken().then(function (res) {
          var formData = new FormData();
          formData.append("file", file);
          formData.append("token", res.data.uptoken);
          axios.post("https://upload.qiniup.com", formData).then(function (res) {
            console.log('res=>', res);
            _this14.form.cover = res.data.data.url;
          });
        });
      }).catch(function (error) {
        console.error('转换为File对象出错', error);
      });
    }
  })
};